/**
 * Sound effects for agent actions
 * Plays audio cues for entry, exit, and different exit types
 */

type SoundType = 'entry' | 'exit-take-profit' | 'exit-stop-loss' | 'exit-order-book';

const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();

function playTone(frequency: number, duration: number, type: OscillatorType = 'sine') {
  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();
  
  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);
  
  oscillator.frequency.value = frequency;
  oscillator.type = type;
  
  gainNode.gain.setValueAtTime(0.1, audioContext.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + duration);
  
  oscillator.start(audioContext.currentTime);
  oscillator.stop(audioContext.currentTime + duration);
}

export function playSound(soundType: SoundType) {
  // Resume audio context if suspended (browser requirement)
  if (audioContext.state === 'suspended') {
    audioContext.resume();
  }

  switch (soundType) {
    case 'entry':
      // Rising tone for entry
      playTone(440, 0.1, 'sine');
      setTimeout(() => playTone(554, 0.1, 'sine'), 100);
      setTimeout(() => playTone(659, 0.15, 'sine'), 200);
      break;
      
    case 'exit-take-profit':
      // Happy ascending sequence for take profit
      playTone(523, 0.1, 'sine');
      setTimeout(() => playTone(659, 0.1, 'sine'), 100);
      setTimeout(() => playTone(784, 0.15, 'sine'), 200);
      setTimeout(() => playTone(1047, 0.2, 'sine'), 300);
      break;
      
    case 'exit-stop-loss':
      // Descending tone for stop loss
      playTone(440, 0.15, 'sawtooth');
      setTimeout(() => playTone(330, 0.15, 'sawtooth'), 150);
      setTimeout(() => playTone(220, 0.2, 'sawtooth'), 300);
      break;
      
    case 'exit-order-book':
      // Neutral tone for order book sell
      playTone(523, 0.1, 'square');
      setTimeout(() => playTone(440, 0.1, 'square'), 100);
      break;
  }
}

export function enableSoundEffects() {
  if (audioContext.state === 'suspended') {
    audioContext.resume();
  }
}
